import {
  Avatar,
  Divider,
  Flex,
  Icon,
  Image,
  Progress,
  Text,
  useColorModeValue,
  WrapItem
} from '@chakra-ui/react';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { HiChevronRight } from 'react-icons/hi';
import { IoIosArrowRoundForward } from 'react-icons/io';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import CopyIcon from '../../../components/CopyComponent/CopyIcon';
import { COMMON_WEB_PATH } from '../../../constant';
import useCurrentVipLevelConfig from '../../../hook/useCurrentVipLevelConfig';
import useNextVipLevelConfig from '../../../hook/useNextVipLevelConfig';
import useVipInfo from '../../../hook/useVipInfo';
import CreditPage from '../../../utils/credit/credit_page';
import VipOpenPage from '../../../utils/credit/vip_open_page';
import { formatNumber } from '../../../utils/formatNumber';
import useLogoutButton from './useLogoutButton';

const ProfileCard = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`profile.${key}`);

  const cardBg = useColorModeValue('light.100', 'dark.100');
  const iconBg = useColorModeValue('brand.500', 'brand.500');
  const textColor = useColorModeValue('dark.100', 'light.100');

  const memberData = useSelector((state) => state.isMemberInfo);
  const { name, uid, memId } = memberData || {};

  const { profileCardLogoutBtn } = useLogoutButton();

  const { current_wager, current_level, current_symbol } = useVipInfo();

  const current_vip_detail = useCurrentVipLevelConfig({
    currentLevel: current_level
  });

  const { next_level_criteria_data, ...others } = useNextVipLevelConfig({
    level: current_level + 1
  });

  const wager_percent = useMemo(() => {
    const result =
      Number(current_wager / next_level_criteria_data?.criteria_amount) * 100;
    if (result > 100) return 100;
    return formatNumber(result, { ignore_crypto: true });
  }, [current_wager, next_level_criteria_data?.criteria_amount]);

  return (
    <Flex
      direction={`column`}
      gap="5px"
      as="section"
      // bg={cardBg}
      borderRadius={`common`}
      p="10px"
    >
      <Flex
        gap="10px"
        pr={{
          base: '20px',
          md: 0
        }}
        justifyContent={`space-between`}
      >
        <Flex maxW="60%" gap="10px">
          <WrapItem
            as={Link}
            to="data"
            p="1px"
            bg={'#6DEFFF'}
            borderRadius={`full`}
          >
            <Avatar
              name="Header Icon"
              src={`${COMMON_WEB_PATH}/ui-image/user-icon-1.avif`}
            />
          </WrapItem>
          <Flex direction={`column`} py="3px" justifyContent={`center`}>
            <Flex gap="3px" alignItems={`center`}>
              <Text
                color={textColor}
                fontWeight={`bold`}
                fontSize="18px"
                maxW={{
                  md: '115px',
                  base: '150px'
                }}
                className="text-overflow"
                as="p"
                my="0"
              >
                {name ? (
                  name
                ) : (
                  <Link to="../profile/settings/personal-data">
                    ({i18n('go_to_set_nick_name')})
                  </Link>
                )}
              </Text>

              <Flex
                borderRadius={'30px'}
                px="5px"
                py="1px"
                bg="#6EEFFF"
                gap="3px"
                alignItems={`center`}
              >
                <Text
                  color={`#2A749B`}
                  fontSize="10px"
                  fontWeight={`semibold`}
                  as="p"
                  my="0"
                >
                  UUID:{uid}
                </Text>
                <CopyIcon copyLink={uid} />
              </Flex>
            </Flex>
            <Flex gap="3px" alignItems={`center`}>
              <Flex alignItems={'center'}>
                <Text
                  className="text-overflow"
                  color={'#6DEFFF'}
                  fontSize="10px"
                  fontWeight={`semibold`}
                  as="p"
                  my="0"
                >
                  {i18n('account')}:
                </Text>
                <Text
                  color={'#6DEFFF'}
                  fontSize="10px"
                  fontWeight={`semibold`}
                  as="p"
                  my="0"
                  maxW="100px"
                  className="text-overflow"
                >
                  {memId}
                </Text>
              </Flex>
              <CopyIcon fontSize="10px" copyLink={memId} />
            </Flex>
          </Flex>
        </Flex>
        {/* <Flex alignItems="center">{profileCardLogoutBtn}</Flex> */}
      </Flex>
      <CreditPage>
        <VipOpenPage>
          <Divider mb="5px" />
          <Flex
            gap="10px"
            justifyContent={`space-between`}
            alignItems={`center`}
          >
            <Image
              src={`${COMMON_WEB_PATH}/vip/vip${current_level}_l.avif`}
              w="35px"
              objectFit={`cover`}
            />
            <Flex gap="10px" justifyContent={`space-between`} w="100%">
              <Flex direction={`column`} justifyContent={`center`}>
                <Text color={textColor} fontWeight="bold" fontSize="md"></Text>
              </Flex>
              <Flex
                direction={`column`}
                gap="3px"
                w="100%"
                alignItems={`center`}
                justifyContent={`space-between`}
              >
                {/* <Text fontSize="xs" fontWeight={`semibold`} color={textColor}>
              {formatNumber(current_wager)}
              XP
            </Text> */}
                <Flex
                  w="100%"
                  alignItems={`center`}
                  justifyContent={`space-between`}
                >
                  <Flex
                    fontSize="10px"
                    fontWeight={`bold`}
                    gap="2px"
                    alignItems={`center`}
                    color="special.1"
                  >
                    <Text>{i18n('your_vip_progress')}</Text>
                    <Icon as={IoIosArrowRoundForward} />
                  </Flex>
                  <Text fontSize="10px" color="special.1" fontWeight={`bold`}>
                    {wager_percent}%
                  </Text>
                </Flex>
                <Progress
                  w="100%"
                  value={wager_percent}
                  size="xs"
                  variant={`brandPrimary`}
                />
                {/* <Text fontSize="xs" color={`special.1`}>
              {formatNumber(next_level_criteria_data?.criteria_amount)} XP
            </Text> */}
                <Flex
                  w="100%"
                  alignItems={`center`}
                  justifyContent={`space-between`}
                >
                  <Text fontSize="10px" fontWeight={`bold`} color="special.1">
                    {current_vip_detail?.name}
                  </Text>
                  <Text fontSize="10px" color="special.1" fontWeight={`bold`}>
                    {others?.name}
                  </Text>
                </Flex>
              </Flex>
            </Flex>
            <Link to="vip">
              <Icon as={HiChevronRight} color="special.1" />
            </Link>
          </Flex>
        </VipOpenPage>
      </CreditPage>
      {/* <LineBind /> */}
    </Flex>
  );
};

export default ProfileCard;
